import { render, staticRenderFns } from "./ReviewsMassDelete.vue?vue&type=template&id=5d371ba2&scoped=true&"
import script from "./ReviewsMassDelete.vue?vue&type=script&lang=js&"
export * from "./ReviewsMassDelete.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsMassDelete.vue?vue&type=style&index=0&id=5d371ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d371ba2",
  null
  
)

export default component.exports